import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

export  const defaultColumns = [
    {
      dataIndex: "GLAccount",
      title: "GL Account",
      width: 200,
      fixed: "left",
    },
    {
      dataIndex: "total",
      title: "Total",
      width: 150,
      fixed: "left",
    },
    {
      dataIndex: "jan",
      title: "Jan",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "feb",
      title: "Feb",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "mar",
      title: "Mar",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "apr",
      title: "Apr",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "may",
      title: "May",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "jun",
      title: "Jun",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "jul",
      title: "Jul",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "aug",
      title: "Aug",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "sep",
      title: "Sep",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "oct",
      title: "Oct",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "nov",
      title: "Nov",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "dec",
      title: "Dec",
      width: 110,
      editable: true,
    },
    {
      dataIndex: "notes",
      title: "Notes",
      width: 150,
      editable: true,
    },
  ];

  export  const data = [];
  for (let i = 0; i < 46; i++) {
    data.push({
      id: i,
      GLAccount: `Account Title ${i}`,
      total: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      jan: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      feb: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      mar: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      apr: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      may: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      jun: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      jul: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      aug: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      sep: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      oct: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      nov: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      dec: `$ ${(Math.round(0 * 100) / 100).toFixed(2)}`,
      notes: "-",
    });
  }

  export const BudgetRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("Annual Budget - Comparative", "1", "", "", ""),
      RightBarMethod("Annual Budget - Forecast", "2", "", "", ""),
      RightBarMethod("Budget Detail", "3", "", "", ""),
      RightBarMethod("Budget - Comparative", "4", "", "", ""),
      RightBarMethod("Budget - Property Comparison", "5", "", "", ""),
    ]),
    RightBarMethod(
      "HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("Edit a Property Budget", "6", "", "", "")]
    ),
  ];